export default __webpack_public_path__ + "f942539f91ad87f17dbaf3352ffbb7ee.png";